import React from 'react';
import { Button } from 'antd';
import { useTheme } from './ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button 
      type="text"
      className="theme-toggle"
      onClick={toggleTheme}
      style={{ color: 'var(--header-text)' }}
    >
      {theme === 'light' ? '🌙' : '☀️'}
    </Button>
  );
};

export default ThemeToggle; 